import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lkd-development',
  templateUrl: './development.component.html',
  styles: []
})
export class DevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
